import { PureComponent } from "react";
import web3 from "web3";
import moment from 'moment';
import _ from "lodash";
import { textMasking, checkTransactionOnExplorer } from "../../../../helper/utils";

export default class OrderInformation extends PureComponent {
    _componentMounted = false;

    constructor(props) {
        super();
        this.state = {}
    }

    componentDidMount = async () => {
        console.log("FulfilledOrder Component mounted");
        this._componentMounted = true;
        if (this._componentMounted) { }
    }

    componentWillUnmount() {
        this._componentMounted = false;
        console.log("FulfilledOrder Component unmounted");
    }

    render() {
        return (
            <>
                <h3><b>Sent</b> <i className="fas fa-chevron-right"></i></h3>
                <h4>
                    {web3.utils.fromWei(this.props.sentTokenQty)} {this.props.sentTokenSymbol}
                    {this.props.status === 'FULFILLED' &&
                        <span>&nbsp;(${ Number(web3.utils.fromWei(this.props.sentTokenQty)) * _.mean(this.props.sentTokenOnDollarPrice ?? [])})</span>
                    }
                </h4>
                {/* <p>Feb 2. 2019, 9:21am PST</p> */}
                <p>{moment.unix(this.props.sentOnTime).format("MMM D[. ]YYYY[, ]h[:]mma zz")}</p>
                <div className="ledger-box">
                    <h5><i><img src="../images/tick.png" width="18px"></img></i>
                    Transaction Submitted </h5>
                    <p>{textMasking(this.props.tranactionHash, '.', 16, 25, 25)}</p>
                    <div className="flex">
                        <a className="cursor" href="#" onClick={() => checkTransactionOnExplorer(this.props.sentFromNetworkConfig?.explorerUrl, this.props.tranactionHash)}>View transaction</a>
                    </div>
                </div>
            </>
        )
    }

}